import { Pipe, PipeTransform } from '@angular/core';

const STATUS_LABEL_MAP: Record<string, string> = {
  // Banco — simples
  PENDING_DOCUMENTATION: 'Pendente documentação',
  PROCESSING: 'Aguardando avaliação',
  REPROVED_WITH_CORRECTION: 'Reprovada',
  CANCELED: 'Cancelada',
  AVAILABLE_QUOTATION: 'Aguardando cotação',
  REPROVED_WITHOUT_CORRECTION: 'Reprovada sem correção',
  PENDING_INVOICE_INFORMATION: 'Pendente informações da invoice',
  PENDING_INVOICE_ATTACHMENT: 'Invoice pendente',
  IDENTIFIED_PAYMENT: 'Efetivada',
  IDENTIFYING_PAYMENT_ABROAD: 'Aguardando pagamento no exterior',
  IDENTIFIED_PAYMENT_ABROAD: 'Pendente informações',
  PENDING_PAYMENT_INFORMATION: 'Pendente informações de pagamento',
  PAYMENT_REPROVED: 'Ordem com pendência',
  PENDING_ORDER_INFORMATION: 'Pendente informações',
  PENDING_LIQUIDATION: 'Fechamento concluído',

  // Derivados
  PAID_LIQUIDATED: 'Liquidada',
  PAYMENT_AWAITING_TREASURY: 'Aguardando informações da tesouraria',
  PAYMENT_READY_TO_SLIP: 'Pronto para boletar',
  PAYMENT_CONFIRM_INBOUND: 'A confirmar pagamento',
  PAYMENT_AWAITING_EFETIVATION: 'Aguardando efetivação',
  EXCHANGE_NO_PENDING: 'Sem pendências',
  EXCHANGE_PENDING_SETTLEMENT_DOC: 'Pendente doc liquidação',
  EXCHANGE_PENDING_OPERATION_DOC: 'Pendente doc operação',
};

@Pipe({
  name: 'orderStatus',
})
export class OrderStatusPipe implements PipeTransform {
  transform(row: any): string {
    const statusFlow = row?.statusFlow;

    const simpleLabel = STATUS_LABEL_MAP[statusFlow];
    if (simpleLabel) {
      return simpleLabel;
    }

    if (statusFlow === 'PAID' && row?.orderSource !== 'EXCHANGE') {
      return 'Liquidada';
    }

    if (statusFlow === 'AVAILABLE_PAYMENT' || statusFlow === 'IDENTIFYING_PAYMENT') {
      return this.resolvePaymentStatus(row);
    }

    if (row?.orderSource === 'EXCHANGE') {
      return this.resolveExchangeStatus(row);
    }

    return '';
  }

  private resolvePaymentStatus(row: any): string {
    if (!row?.confirmationTreasury) {
      return 'Aguardando informações da tesouraria';
    }

    if (!row?.confirmationSlip) {
      return 'Pronto para boletar';
    }

    if (row?.remmitanceType === 'OUTBOUND') {
      return 'Aguardando Efetivação';
    }

    if (row?.remmitanceType === 'INBOUND') {
      return 'A confirmar pagamento';
    }

    return '';
  }

  private resolveExchangeStatus(row: any): string {
    const settlement = row?.orderSettlement;
    const hasContractOrProof =
      settlement?.exchangeContractFile || settlement?.proofOperationFile;
    const hasAttachments =
      settlement?.orderSettlementAttachments?.length > 0;

    if (hasContractOrProof && hasAttachments) {
      return 'Sem pendências';
    }

    if (!hasContractOrProof) {
      return 'Pendente doc liquidação';
    }

    if (hasContractOrProof && !hasAttachments) {
      return 'Pendente doc operação';
    }

    return '';
  }
}
